import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { buildApiUrl, API_ENDPOINTS } from "../config/api";

export default function PrivateRouteOrgAdmin({ children }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const response = await fetch(buildApiUrl(API_ENDPOINTS.current), {
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) {
          localStorage.removeItem("userType");
          setStatus("unauth");
          return;
        }

        const data = await response.json();
        const type = data?.datosUsuario?.type;

        if (type) localStorage.setItem("userType", type);

        const allowed = ["admin", "orgAdmin"].includes(type);
        setStatus(allowed ? "ok" : "forbidden");
      } catch {
        setStatus("unauth");
      }
    };

    checkAccess();
  }, []);

  if (status === null) return <div>Verificando autenticación...</div>;
  if (status === "unauth") return <Navigate to="/login" replace />;
  if (status === "forbidden") return <Navigate to="/" replace />;

  return children;
}
